import * as React from 'react';
import styled from 'styled-components';

interface MarkdownProps {
	markdown?: string;
	escapeHtml?: boolean;
}

interface MarkdownState {}

export class Markdown extends React.Component<MarkdownProps, MarkdownState> {
	render() {
		return (
			<Container>
				<div>{this.props.markdown}</div>
			</Container>
		);
	}
}

const Container = styled.div`
	color: #000;
	margin-bottom: 2rem;
	& > h1 {
		margin-top: 1rem;
		margin-bottom: 0.8rem;
		font-size: 1rem;
		color: ${(p) => p.theme.colors.primary};
		font-weight: bold;
	}
	& > h2 {
		margin-top: 0.9rem;
		margin-bottom: 0.7rem;
		font-size: 0.95rem;
		color: ${(p) => p.theme.colors.primary};
		font-weight: bold;
	}
	& > h3 {
		margin-top: 0.8rem;
		margin-bottom: 0.6rem;
		font-size: 0.9rem;
		color: ${(p) => p.theme.colors.primary};
		font-weight: bold;
	}
	& > h4 {
		margin-top: 0.7rem;
		margin-bottom: 0.5rem;
		font-size: 0.85rem;
		color: ${(p) => p.theme.colors.primary};
		font-weight: bold;
	}
	& > ul,
	& > ol {
		margin: 1rem;
	}
	& > ul > li,
	& > ol > li {
		&:not(:last-child) {
			margin-bottom: 0.5rem;
		}
		& a {
			word-wrap: break-word;
			word-break: break-all;
		}
	}
	& > ul > li > p,
	& > ol > li > p {
		display: inline;
	}
	& > h1 + ul,
	& > h2 + ul,
	& > h3 + ul,
	& > h4 + ul {
		margin-top: 0rem;
	}
	& > pre {
		margin: 1rem 0rem;
		& > code {
			white-space: pre-wrap;
			font-family:
				Montserrat,
				-apple-system,
				BlinkMacSystemFont,
				'Segoe UI',
				'Roboto',
				'Oxygen',
				'Ubuntu',
				'Cantarell',
				'Fira Sans',
				'Droid Sans',
				'Helvetica Neue',
				sans-serif;
		}
	}
`;
